import client from "../client";

const doLogin = (props: any, language: string) =>
  client.post<any>(`/login/doLogin/${language}`, props);

const loginApi = {
  doLogin,
};
export default loginApi;
